import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconCheckBoxChecked = (props) => {
  props = Object.assign({viewBox: '0 0 30 30'}, props);
  return (
    <SvgIcon {...props}>
      <path
        d="M27,15 C27,21.627 21.627,27 15,27 C8.373,27 3,21.627 3,15 C3,8.373 8.373,3 15,3 C21.627,3 27,8.373 27,15"
        id="Fill-1"></path>
      <polygon id="Fill-3" fill="#FFFFFF"
               points="21.6249 9.7973 12.2609 19.1613 8.3749 15.2753 7.3409 16.3093 12.2609 21.2293 22.6589 10.8313"></polygon>
    </SvgIcon>
  );
};

IconCheckBoxChecked.displayName = 'IconCheckBoxChecked';
IconCheckBoxChecked.muiName = 'SvgIcon';

export default IconCheckBoxChecked;



// WEBPACK FOOTER //
// ./src/components/Icons/IconCheckBoxChecked.js